import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {MdDialog, MdDialogConfig, MdDialogRef} from '@angular/material';
import {ImportController} from './import.controller';
import {SnackBarService} from '../../services/snackbar.service';
import {DataImportedReview} from './dataImported.model';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.css']
})
export class ImportComponent implements OnInit {

  dialogRef: MdDialogRef<any>;
  hasPassword = false;
  file: any;
  password= '';
  showPassword = false;
  clients: any[] = [];
  counterParties: any[] = [];
  banks: any[] = [];
  accounts: any[] = [];
  isLoading = false;
  showResult = false;
  showImportResult = false;
  dataToReview: DataImportedReview;
  isEditingSession = false; // Flag to track if we're editing an existing session
  
  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private importController: ImportController,
    private snackBarService: SnackBarService
  ) { }

  ngOnInit() {
    this.loadActiveSession();
  }

  /**
   * Load active session on component initialization
   */
  loadActiveSession() {
    this.isLoading = true;
    this.importController.getActiveSession().subscribe({
      next: (session) => {
        console.log('Active session:', session);
        if (session && session.dataReview) {
          this.dataToReview = session.dataReview;
          this.showResult = true;
          this.isEditingSession = true;
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading active session:', error);
        this.isLoading = false;
      }
    });
  }

  importData() {
    console.log('file => ', this.file);
    console.log('password => ', this.password);
    console.log('clients.', this.clients);
    this.isLoading = true;
    this.showResult = false;
    
    // Use session-based import instead of traditional review
    this.importController.buildSessionFromExcel(this.file, this.password).subscribe({
      next: (session) => {
        console.log('Session built from Excel:', session);
        if (session && session.dataReview) {
          this.dataToReview = session.dataReview;
          this.file = null;
          this.password = '';
          this.hasPassword = false;
          this.isLoading = false;
          this.showResult = true;
          this.isEditingSession = true;
        } else {
          this.snackBarService.showSimpleMsj('Failed to build session from Excel');
          this.isLoading = false;
        }
      },
      error: (error) => {
        console.error(error._body);
        this.snackBarService.showSimpleMsj(error._body);
        this.isLoading = false;
      }
    });
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    console.log('input => ', input);
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
      console.log('Archivo seleccionado:', this.file.name);
    }

  }

  /**
   * Handle mapping changes - auto-save to session
   */
  onMappingChange(dataReview: DataImportedReview) {
    console.log('Auto-saving mapping changes to session...', dataReview);
    
    // Silently update session without blocking UI
    this.importController.updateSession(dataReview).subscribe({
      next: () => {
        console.log('Mapping changes auto-saved');
        // Update local data after successful save
        this.dataToReview = dataReview;
      },
      error: (error) => console.warn('Failed to auto-save mappings:', error)
    });
  }

  /**
   * Save mappings without importing
   */
  save(dataReview: DataImportedReview) {
    console.log('Saving mappings to session...', dataReview);
    this.isLoading = true;
    
    // Update the active session with the modified data
    this.importController.updateSession(dataReview).subscribe({
      next: (updatedSession) => {
        console.log('Mappings saved to session:', updatedSession);
        this.isLoading = false;
        this.showResult = true;
        this.dataToReview = dataReview;
        this.snackBarService.showSimpleMsj('Mappings saved successfully');
      },
      error: (error) => {
        console.error('Error saving session:', error);
        this.isLoading = false;
        this.showResult = true;
        this.snackBarService.showSimpleMsj('Failed to save mappings: ' + error._body);
      }
    });
  }

  /**
   * Execute the actual import
   */
  import(dataReview: DataImportedReview) {
    console.log('Executing import...', dataReview);
    this.isLoading = true;
    this.showResult = false;
    
    // Execute the import
    this.importController.saveImport(dataReview).subscribe({
      next: (response) => {
        console.log('Import completed:', response);
        this.isLoading = false;
        this.clients = response.clients;
        this.counterParties = response.counterParties;
        this.banks = response.banks;
        this.accounts = response.accounts;
        this.showImportResult = true;
        this.snackBarService.showSimpleMsj('Import completed successfully');
      },
      error: (error) => {
        console.error(error._body);
        this.isLoading = false;
        this.showImportResult = false;
        this.showResult = true;
        this.snackBarService.showSimpleMsj(error._body);
      }
    });
  }
}





// WEBPACK FOOTER //
// ./src/app/admin/import/import.component.ts